module.exports = __webpack_public_path__ + "img/Weapon_254.85145c74.png";